module.exports = {
  template: require('./clients-list-container.pug')()
  controller: require('./clients-list-container.ctrl')
  bindings:
    salon: '<'
}
